import { FC } from "react";
import {
    DocumentList,
    Space,
    SimpleCard,
} from "../../../design-system";
import type { DocumentItem } from "../../../design-system";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { PlainLightPanelless } from "survey-core/themes";
import "survey-core/survey-core.css";

import { ProjectAnalysisInput } from "../../../types/ProjectTypes";
import styles from "../ProjectView.module.less";

interface InputViewerProps {
    input: ProjectAnalysisInput;
}

export const InputViewer: FC<InputViewerProps> = ({ input }) => {
    const uploaderName = `${input.creator.firstName} ${input.creator.lastName}`;
    const documents: DocumentItem[] = input.documents.map((d) => ({
        id: d.id,
        name: d.document.name,
        change: d.change,
        uploadedBy: uploaderName,
        uploadedAt: d.document.uploadDate,
    }));

    let surveyModel: Model | null = null;
    if (input.survey?.schema) {
        surveyModel = new Model(input.survey.schema);
        surveyModel.applyTheme(PlainLightPanelless);
        surveyModel.showCompleteButton = false;
        surveyModel.readOnly = true;
        if (input.survey.response) {
            surveyModel.data = input.survey.response;
        }
    }

    return (
        <Space direction="vertical" size="large" fullWidth>
            {documents.length > 0 && (
                <SimpleCard header="Documents" headerType="primary">
                    <DocumentList readOnly documents={documents} />
                </SimpleCard>
            )}

            {surveyModel && (
                <SimpleCard header="Context" headerType="primary">
                    <SimpleCard type="white">
                        <div className={styles.surveyContainer}>
                            <Survey model={surveyModel} />
                        </div>
                    </SimpleCard>
                </SimpleCard>
            )}
        </Space>
    );
};
